import FeaturedEventView from '@/modules/HomePage/components/FeaturedEvent/FeaturedEventView';
import useHomepageContext from '@/modules/HomePage/HomePageContext';

const FeaturedEvent = () => {
  const { featuredEvent } = useHomepageContext();

  return featuredEvent ? <FeaturedEventView event={featuredEvent} /> : null;
};

export default FeaturedEvent;
